import { useState } from 'react';

import { FileApi } from '@api/file-api';
import { store } from '@store';
import { FileAsset as StoreFileAsset } from '@store/models/FileAsset';
import { translate } from '@chaika/i18n/helper';

interface Params {
    asset: StoreFileAsset;
    onDeleteCLick(fileName: string): void;
}

interface Data {
    isDeletingPopupShowing: boolean;
    onShowFileClick(): Promise<void>;
    onDownloadFileClick(): Promise<void>;
    onSharePacs(): Promise<void>;
    onDeleteClick(): void;
    onConfirmDeleting(): Promise<void>;
    onCancelDeleting(): void;
}

export function useFileAsset({ asset, onDeleteCLick }: Params): Data {
    const [isDeletingPopupShowing, setIsDeletingPopupShowing] = useState(false);

    const onShowFileClick = async (): Promise<void> => {
        await FileApi.showFile(asset.path);
    };

    const onDownloadFileClick = async (): Promise<void> => {
        await FileApi.downloadFile(asset.path);
    };

    const onSharePacs = async (): Promise<void> => {
        store.app.doOrShowError({
            showLoader: false,
            action: async () => FileApi.sharePacs(asset.path),
        });
    };

    const onDeleteClick = (): void => {
        setIsDeletingPopupShowing(true);
    };

    const onConfirmDeleting = async (): Promise<void> => {
        try {
            await onDeleteCLick(asset.name);
            // popup closing will not be necessary as by the time the component will have been unmounted
        } catch (e: any) {
            setIsDeletingPopupShowing(false);
            store.app.showingPopupParams = {
                title: translate('errorOnFileDeleting'),
                description: e.message,
            };
        }
    };

    const onCancelDeleting = (): void => {
        setIsDeletingPopupShowing(false);
    };

    return {
        isDeletingPopupShowing,
        onShowFileClick,
        onDownloadFileClick,
        onSharePacs,
        onDeleteClick,
        onConfirmDeleting,
        onCancelDeleting,
    };
}
